/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_FECHA_DATOS,
    CASILLA_TEXTO,
    CASILLA_TEXTOS
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerPlaca} from "../../Utilidades/obtenerPlaca";
import Dialogo_Lista_Checks from "../Dialogos/Dialogo_Lista_Checks";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import ExportadorDatosListaConductor from "../Componentes/ExportadorDatosListaConductor";


const Seccion_Listas_Checkeo_Conductor = () => {
    const [w, setW] = useState([where('idConductor', '==', 'none')])
    const {
        props,
        setData,
        cargarNuevamente,
        setNumeroFilas
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'listascheckeo', wheres: w})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Lista_Checks,
        titulo: 'Detalles de la lista de checkeo',
        realizado: cargarNuevamente
    })
    const parms = useParams()
    const [cargando, setCargando] = useState(false)
    const [conductor, setConductor] = useState({})

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }

    const buscar = async (e) => {
        console.log(e)
        let placa = obtenerPlaca(e)
        let w = [where('placa', '==', placa), where('idConductor', '==', conductor.id)]
        setCargando(true)
        let doxs = await obtenerColWheres({col: 'listascheckeo', wheres: w})
        if (doxs.res && doxs.data.length > 0) {
            setNumeroFilas(doxs.data.length)
            setData(doxs.data)
        } else {
            setData([])
            setNumeroFilas(0)
        }
        setCargando(false)

    }

    const CompoInferior = () => {
        return <ExportadorDatosListaConductor conductor={conductor}/>
    }


    useEffect(() => {

        if (parms && parms.id) {
            setCargando(true)
            obtenerDoc('conductores', parms.id).then((dox) => {
                if (dox.res) {
                    setConductor(dox.data)
                    let w = [where('idConductor', '==', dox.data.id)]
                    setW(w)
                }
                setCargando(false)
            })
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Listas de ${conductor.nombres} ${conductor.apellidos}`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        funcionBuscar={buscar}
                        placeholderBarra={'Placas del Vehiculo'}
                        cargando={cargando}
                        ComponenteInferior={CompoInferior}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Listas_Checkeo_Conductor

const filtros = [
    {
        nombre: 'Placa',
        direccion: 'asc',
        propiedad: 'placa'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombres', 'apellidos'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Placa',
        direccion: 'left',
        propiedad: 'placa',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Marca Modelo',
        direccion: 'left',
        propiedades: ['marca', 'modelo'],
        tipo: CASILLA_TEXTOS

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'tipo',
        tipo: CASILLA_TEXTO
    }

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]